import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tokenBe:0
  },
  mutations: {
    setTokenBe(state,token){
      state.tokenBe = token
    }
  },
  actions: {

  },
  modules: {

  }
})
